module.exports = __webpack_public_path__ + "static/media/8. Speaker Aditi Balbir.34049cea.png";